import * as React from 'react';
import {
  BooleanInput,
  TextInput,
  SelectInput,
  ReferenceInput,
  AutocompleteInput,
  FormDataConsumer,
} from 'react-admin';
import moment from 'moment';

const HomeSectionSeeAll = ({ isCreate = false, localizedSource }) => {
  const seeAllTitleSource =
    typeof localizedSource === 'function' ? localizedSource('seeAll.title') : 'seeAll.title.tr';

  return (
    <React.Fragment>
      <h3>See All Details</h3>
      <BooleanInput
        label="Show See All Button?"
        source="seeAll.isEnabled"
        defaultValue={isCreate ? false : undefined}
        defaultChecked={isCreate ? false : undefined}
      />
      <FormDataConsumer>
        {({ formData }) => {
          return (
            formData.seeAll &&
            formData.seeAll.isEnabled && (
              <React.Fragment>
                <TextInput
                  source={seeAllTitleSource}
                  label="See All Title"
                  fullWidth
                  defaultValue={isCreate ? '' : undefined}
                />
                <SelectInput
                  source="seeAll.link.type"
                  label={'See All Link'}
                  fullWidth
                  defaultValue={isCreate ? '' : undefined}
                  choices={[
                    { id: 'groupEvent', name: 'Group Event' },
                    { id: 'venue', name: 'Venue' },
                    {
                      id: 'organisationCompany',
                      name: 'Organisation Company',
                    },
                  ]}
                />

                <FormDataConsumer>
                  {({ formData: inner }) => {
                    if (!inner?.seeAll?.link?.type) {
                      return null;
                    }
                    if (inner.seeAll.link.type === 'groupEvent') {
                      return (
                        <ReferenceInput
                          source="seeAll.link.id"
                          reference="groupEvents"
                          label="Group Event Filter"
                          sort={{ field: 'name', order: 'ASC' }}
                        >
                          <AutocompleteInput
                            optionText={(r) =>
                              `${r.name} - ${moment(r.startdate).format('DD-MM-YYYY')}`
                            }
                            matchSuggestion={() => true}
                            filterToQuery={(searchText) => ({
                              name: searchText,
                            })}
                            label="Group Event Name"
                            fullWidth
                          />
                        </ReferenceInput>
                      );
                    }
                    if (inner.seeAll.link.type === 'venue') {
                      return (
                        <ReferenceInput
                          source="seeAll.link.id"
                          reference="venues"
                          label="Venue Filter"
                          sort={{ field: 'name', order: 'ASC' }}
                          perPage={200}
                        >
                          <AutocompleteInput
                            optionText={(r) => `${r.name}`}
                            matchSuggestion={() => true}
                            filterToQuery={(searchText) => ({
                              name: searchText,
                            })}
                            label="Venue Name"
                            fullWidth
                          />
                        </ReferenceInput>
                      );
                    }
                    if (inner.seeAll.link.type === 'organisationCompany') {
                      return (
                        <ReferenceInput
                          source="seeAll.link.id"
                          reference="organisationCompanies"
                          label="Organisation Company Filter"
                          sort={{ field: 'name', order: 'ASC' }}
                        >
                          <AutocompleteInput
                            optionText={(r) => `${r.name}`}
                            matchSuggestion={() => true}
                            filterToQuery={(searchText) => ({
                              name: searchText,
                            })}
                            label="Organisation Company Name"
                            fullWidth
                          />
                        </ReferenceInput>
                      );
                    }
                    return null;
                  }}
                </FormDataConsumer>
              </React.Fragment>
            )
          );
        }}
      </FormDataConsumer>
    </React.Fragment>
  );
};

export default HomeSectionSeeAll;
